import { IMAGES_CDN_URL } from "@/config/constants";

// Cache to track already preloaded images and store Image objects
const preloadedImages = new Map<string, HTMLImageElement>();

/**
 * Preloads an image by creating an Image object
 * The Image object is cached and can be retrieved later
 */
export const preloadImage = (src: string): Promise<void> =>
	new Promise(
		(
			resolve: CallableFunction,
			// reject: CallableFunction,
		): void => {
			const url = `${IMAGES_CDN_URL}${src}`;

			// If already preloaded, resolve immediately
			if (preloadedImages.has(url)) {
				// console.error(`[PRELOAD] Already cached: ${url}`);
				return resolve();
			}

			// console.error(`[PRELOAD] Loading: ${url}`);

			// Create Image object - browser will cache this
			const image = new Image();
			image.src = url;

			image.onload = (): void => {
				// Store the loaded image to prevent duplicate requests
				preloadedImages.set(url, image);
				// console.error(`[PRELOAD] Loaded successfully: ${url}`);
				resolve();
			};

			image.onerror = (): void => {
				// Even on error, mark as attempted to avoid retry loops
				// console.error(`[PRELOAD] Failed to load: ${url}`);
				resolve();
			};
		},
	);

/**
 * Gets the full URL for an image path
 * This ensures the same URL construction used in preload
 */
export const getImageUrl = (src: string): string => {
	const url = `${IMAGES_CDN_URL}${src}`;
	// console.error(`[GET_URL] Constructing URL: ${url}`);
	return url;
};
